import { render, staticRenderFns } from "./FinMonthStatistics.vue?vue&type=template&id=11ff0a2e&scoped=true&"
import script from "./FinMonthStatistics.vue?vue&type=script&lang=js&"
export * from "./FinMonthStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ff0a2e",
  null
  
)

export default component.exports